import { api } from './client';

const apiBase = (process.env.REACT_APP_API_URL || 'http://localhost:4100/api').replace(/\/+$/, '');

export const AuthAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (payload) => api.post('/auth/register', payload),
  verifyEmail: (token) => api.get('/auth/verify-email', { params: { token } }),
  resendVerification: (email) => api.post('/auth/resend-verification', { email }),
  requestReset: (email) => api.post('/auth/forgot-password', { email }),
  verifyResetToken: (token) => api.get('/auth/reset-password/verify', { params: { token } }),
  resetWithToken: (token, new_password) => api.post('/auth/reset-password', { token, new_password }),
  changePassword: (old_password, new_password) => api.post('/auth/change-password', { old_password, new_password }),
  logout: () => api.post('/auth/logout'),
  me: () => api.get('/auth/me'),
  session: () => api.get('/auth/session'),
  bootstrap: () => api.get('/auth/bootstrap'),
  getEnterprise: () => api.get('/enterprise/me'),
  getEnterpriseUsers: () => api.get('/enterprise/me/users'),
  getEnterpriseMemberships: () => api.get('/enterprise/me/memberships'),
  getEnterpriseRoles: () => api.get('/enterprise/me/roles'),
  createEnterpriseRole: (payload) => api.post('/enterprise/me/roles', payload),
  updateEnterpriseRole: (id, payload) => api.patch(`/enterprise/me/roles/${id}`, payload),
  deleteEnterpriseRole: (id) => api.delete(`/enterprise/me/roles/${id}`),
  getEnterpriseRoleUsers: () => api.get('/enterprise/me/role-users'),
  createEnterpriseRoleUser: (payload) => api.post('/enterprise/me/role-users', payload),
  updateEnterpriseRoleUser: (id, payload) => api.patch(`/enterprise/me/role-users/${id}`, payload),
  deleteEnterpriseRoleUser: (id) => api.delete(`/enterprise/me/role-users/${id}`),
  googleStartUrl: (returnTo = '/') => `${apiBase}/auth/google/start?returnTo=${encodeURIComponent(returnTo)}`,
  googleSignupStartUrl: (returnTo = '/') => `${apiBase}/auth/google/signup/start?returnTo=${encodeURIComponent(returnTo)}`,
  m365StartUrl: (returnTo = '/') => `${apiBase}/auth/m365/start?returnTo=${encodeURIComponent(returnTo)}`,
  m365SignupStartUrl: (returnTo = '/') => `${apiBase}/auth/m365/signup/start?returnTo=${encodeURIComponent(returnTo)}`,
};
